import React from "react";
import { ExternalLink } from "lucide-react";

/**
 * Small reusable "card preview" for a hydrated attendee.
 * Used by LiveWall's TapinRow to inline-expand the person's tap-card.
 */
export function AttendeeMiniCard({ att: a }) {
  return (
    <div className="rounded-2xl bg-stone-50 border border-stone-200 p-3 flex items-start gap-2" data-testid="attendee-mini-card">
      <div className="flex-1 min-w-0">
        <div className="text-[11px] font-bold text-stone-900">{a.title || "—"}{a.company && ` · ${a.company}`}</div>
        {a.bio && <p className="text-[11px] text-stone-600 line-clamp-2 mt-0.5">{a.bio}</p>}
        <div className="mt-1 flex flex-wrap gap-1">
          {(a.skills || []).slice(0, 5).map((s, i) => (
            <span key={i} className="text-[10px] font-bold bg-emerald-50 text-emerald-800 rounded-full px-2 py-0.5">{s}</span>
          ))}
        </div>
      </div>
      {a.card_slug && (
        <a href={`/c/${a.card_slug}`} target="_blank" rel="noreferrer"
           className="text-[11px] font-black text-fuchsia-700 hover:underline shrink-0 inline-flex items-center gap-1"
           data-testid="attendee-view-card">
          Card <ExternalLink size={10}/>
        </a>
      )}
    </div>
  );
}
